export const LANGS = ['en', 'de', 'vi'] as const;
export type Lang = (typeof LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = { en: 'EN', de: 'DE', vi: 'VI' };

type LocalizedLike = Record<string, string | undefined> | null | undefined;

/** Resolve a localized JSON value for a language, falling back to English, then anything present. */
export function loc(value: LocalizedLike, lang: string = 'en'): string {
  if (!value) return '';
  return value[lang] ?? value.en ?? Object.values(value).find((v): v is string => !!v) ?? '';
}

/** Drop empty-string entries; returns undefined if nothing is left. */
export function compactLocalized(
  value: Record<string, string>,
): Record<string, string> | undefined {
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(value)) {
    if (v && v.trim()) out[k] = v.trim();
  }
  return Object.keys(out).length ? out : undefined;
}
